export class SuspendedPermitViewModel{
    siteId: number  
    categoryId: number
    permitTypeId:number
}